import ItemBreakpoint from 'Custom/ItemBreakpoint';
import Link from 'node_modules/next/link';
import styles from 'styles/pages/sideEffects.module.scss';

const OTHER_PROBLEMS_LIST = [
  'Vasovagal reactions (such as a drop in blood pressure, dizziness, or fainting)',
  'Pain, irritation, swelling, or bruising at the insertion site',
  'Numbness and tingling at the insertion site',
  'Scarring, including a thick scar called a keloid around the insertion site',
  'Infection',
  'Scar tissue may form around the implant making it difficult to remove',
  'The implant may come out by itself. You may become pregnant if the implant comes out by itself. Use a back-up birth control method and call your healthcare professional right away if the implant comes out',
  'The need for surgery in the hospital to remove the implant',
  'Injury to nerves or blood vessels in your arm',
  'The implant breaks, making removal difficult',
];

const BLOOD_CONDITIONS_LIST = [
  'Legs (deep vein thrombosis)',
  'Lungs (pulmonary embolism)',
  'Brain (stroke)',
  'Heart (heart attack)',
  'Eyes (total or partial blindness)',
];

const OTHER_RISKS_LIST = [
  'High blood pressure',
  'Gallbladder problems',
  'Rare cancerous or noncancerous liver tumors',
];

const MENSTRUL_PERIODS_LIST = [
  'Longer or shorter bleeding during your period',
  'No bleeding at all during the time of your period',
  'Spotting between your periods',
  'Varied amounts of time between your periods',
];

export const SE_LIST_1 = [
  'Mood swings',
  'Depressed mood',
  'Weight gain',
  'Headache',
  'Acne',
];

export const SE_LIST_2 = [
  'Headache',
  'Vaginitis (inflammation of the vagina)',
  'Weight gain',
  'Acne',
  'Breast pain',
  'Viral infections such as sore throats or flu-like symptoms',
  'Stomach pain',
  'Painful periods',
  'Mood swings, nervousness, or depressed mood',
  'Back pain',
  'Nausea',
  'Dizziness',
  'Pain',
  'Pain at the site of insertion',
];

export const SE_TABLE_1 = [
  {
    title: 'Changes in menstrual bleeding patterns (menstrual periods)',
    body: (
      <>
        <p data-qa-tag="nexplanon-menstrual-changes">
          In studies, 1 in 10 women stopped using NEXPLANON because of an
          unfavorable change in their bleeding pattern. You may have:
        </p>
        {MENSTRUL_PERIODS_LIST && (
          <ul data-qa-tag="nexplanon-menstrual-changes-list">
            {MENSTRUL_PERIODS_LIST.map((item, i) => (
              <li data-qa-tag={`nexplanon-menstrual-changes-item-${i}`} key={`faq-se-mp-single${i}`}>{item}</li>
            ))}
          </ul>
        )}
        <p data-qa-tag="nexplanon-menstrual-changes-warning">
          Tell your doctor immediately if you think you may be pregnant or your
          menstrual bleeding is heavy and prolonged.
        </p>
      </>
    ),
  },
  {
    title:
      'Other frequent side effects that cause women to stop using NEXPLANON include:',
    body: (
      <ItemBreakpoint>
        <>
          {SE_LIST_1 && (
            <div className={`${styles.splittedList} ${styles.noMargin}`}>
              <ul>
                {SE_LIST_1.slice(0, 3).map((item, i) => (
                  <li key={`faq-wte-se1-1${i}`}>{item}</li>
                ))}
              </ul>
              <ul>
                {SE_LIST_1.slice(3, 5).map((item, i) => (
                  <li key={`faq-wte-se1-2-${i}`}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </>
        <div className={styles.mobileList}>
          {SE_LIST_1 && (
            <ul>
              {SE_LIST_1.map((item, i) => (
                <li key={`faq-wte-se1-single${i}`}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      </ItemBreakpoint>
    ),
  },
  {
    title: 'Other common side effects of NEXPLANON:',
    body: (
      <>
        <ItemBreakpoint>
          <>
            {SE_LIST_2 && (
              <div className={`${styles.splittedList} ${styles.noMargin}`}>
                <ul>
                  {SE_LIST_2.slice(0, 7).map((item, i) => (
                    <li key={`faq-wte-se-1-${i}`}>{item}</li>
                  ))}
                </ul>
                <ul>
                  {SE_LIST_2.slice(7, 15).map((item, i) => (
                    <li key={`faq-wte-se-2-${i}`}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </>
          <div className={styles.mobileList}>
            {SE_LIST_2 && (
              <ul>
                {SE_LIST_2.map((item, i) => (
                  <li key={`faq-wte-se-single-${i}`}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        </ItemBreakpoint>
        <p className={styles.mt}>
          Implants have been reported to be found in a blood vessel, including a
          blood vessel in the lung, which can be associated with shortness of
          breath, cough, and/or the coughing up of blood or blood-stained mucus.
        </p>
        <p>
          This is not a complete list of possible side effects. For more
          information, ask your healthcare professional for advice about any
          side effects that concern you. You may report side effects to the FDA
          at{' '}
          <Link
            data-design-category="content_link_vd"
            className={styles.phoneLink}
            href="tel:18003321088"
          >
            1-800-FDA-1088
          </Link>
          .
        </p>
      </>
    ),
  },
];

export const CONDITIONS_TABLE = {
  content: [
    'DIABETES',
    'HIGH CHOLESTEROL',
    'HIGH TRIGLYCERIDES',
    'HEADACHES',
    'GALLBLADDER PROBLEMS',
    'KIDNEY PROBLEMS',
    'HISTORY OF DEPRESSION',
    'HIGH BLOOD PRESSURE',
  ],
  footnote: (
    <p data-qa-tag="nexplanon-footnote" className="body-text">
      Before getting NEXPLANON, please tell the trained healthcare professional
      if you have any allergies to numbing medicines or antiseptics used to
      clean your skin. These medicines will be used when the implant is placed
      into or removed from your arm.
    </p>
  ),
};

export const SE_TABLE_2 = [
  {
    title: 'Improper insertion',
    body: (
      <>
        <p>
          The implant may not be placed in your arm due to a failed insertion.
          If this happens, you may become pregnant.
        </p>
        <p>
          To ensure NEXPLANON is properly inserted, immediately after insertion,
          you and your healthcare professional will feel for the implant under
          your skin. If you can’t feel the implant, be sure to tell your
          healthcare professional.
        </p>
      </>
    ),
  },
  {
    title: 'Location and removal may be difficult',
    body: (
      <>
        <p>
          Location and removal of the implant may be difficult or impossible if
          the implant is not where it should be. Special procedures, including
          surgery in the hospital, may be needed to remove the implant. If the
          implant is not removed, the effects of NEXPLANON will continue for a
          longer period of time.
        </p>
        <p>
          Implants have been found in the pulmonary artery (a blood vessel in
          the lung). If the implant cannot be found in the arm, your healthcare
          professional may use <span className="nowrap">X-rays</span> or other
          imaging methods on the chest. If the implant is located in the chest,
          surgery may be needed.
        </p>
      </>
    ),
  },
  {
    title: 'Other problems related to insertion and removal',
    body: (
      <ItemBreakpoint>
        <>
          {OTHER_PROBLEMS_LIST && (
            <div className={`${styles.splittedList} ${styles.noMargin}`}>
              <ul>
                {OTHER_PROBLEMS_LIST.slice(0, 5).map((item, i) => (
                  <li key={`faq-se-op-1${i}`}>{item}</li>
                ))}
              </ul>
              <ul>
                {OTHER_PROBLEMS_LIST.slice(5, 10).map((item, i) => (
                  <li key={`faq-se-op-2-${i}`}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </>
        <div className={styles.mobileList}>
          {OTHER_PROBLEMS_LIST && (
            <ul>
              {OTHER_PROBLEMS_LIST.map((item, i) => (
                <li key={`faq-se-op-single${i}`}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      </ItemBreakpoint>
    ),
  },
  {
    title: 'Ectopic pregnancy',
    body: (
      <>
        <p>
          If you become pregnant while using NEXPLANON, you have a slightly
          higher chance that the pregnancy will be ectopic (occurring outside
          the womb) than do women who do not use birth control.
        </p>
        <p>
          Unusual vaginal bleeding or lower stomach (abdominal) pain may be a
          sign of ectopic pregnancy.
        </p>
        <p>
          Ectopic pregnancy is a medical emergency that often requires surgery.
        </p>
        <p>
          Ectopic pregnancies can cause serious internal bleeding, infertility,
          and even death. Call your healthcare professional right away if you
          think you are pregnant or have unexplained lower stomach (abdominal)
          pain.
        </p>
      </>
    ),
  },
  {
    title: 'Ovarian cysts and breast cancer',
    body: (
      <>
        <p>
          Cysts may develop on the ovaries and usually go away without
          treatment, but sometimes surgery is required to remove them.
        </p>
        <p>
          It is not known whether NEXPLANON use changes a woman’s risk for
          breast cancer. If you have breast cancer now, or have had it in the
          past, do not use NEXPLANON because some breast cancers are sensitive
          to hormones.
        </p>
      </>
    ),
  },
  {
    title: 'Serious blood clots',
    body: (
      <>
        <p>
          NEXPLANON may increase your chance of serious blood clots, especially
          if you have other risk factors such as smoking. It is possible to die
          from a problem caused by a blood clot, such as a heart attack or a
          stroke.
        </p>
        <p>Some examples of serious blood clots are blood clots in the:</p>
        <ItemBreakpoint>
          <>
            {BLOOD_CONDITIONS_LIST && (
              <div className={styles.splittedList}>
                <ul>
                  {BLOOD_CONDITIONS_LIST.slice(0, 3).map((item, i) => (
                    <li key={`faq-bc-op-1${i}`}>{item}</li>
                  ))}
                </ul>
                <ul>
                  {BLOOD_CONDITIONS_LIST.slice(3, 5).map((item, i) => (
                    <li key={`faq-bc-op-2-${i}`}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </>
          {BLOOD_CONDITIONS_LIST && (
            <div className={styles.mobileList}>
              <ul>
                {BLOOD_CONDITIONS_LIST.map((item, i) => (
                  <li key={`faq-bc-op-21${i}`}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </ItemBreakpoint>
        <p>
          The risk of serious blood clots is increased in women who smoke. If
          you smoke and want to use NEXPLANON, you should quit. Your healthcare
          professional may be able to help.
        </p>
        <p>
          Tell your healthcare professional at least 4 weeks before if you are
          going to have surgery or will need to be on bed rest. You have an
          increased chance of getting blood clots during surgery or bed rest.
        </p>
      </>
    ),
  },
  {
    title: 'Other risks',
    body: (
      <>
        <p>
          A few women who use birth control that contains hormones may
          experience:
        </p>
        {OTHER_RISKS_LIST && (
          <ul>
            {OTHER_RISKS_LIST.map((item, i) => (
              <li key={`faq-se-op-single${i}`}>{item}</li>
            ))}
          </ul>
        )}
        <p>
          If you feel you have a broken or bent implant, please contact your
          doctor.
        </p>
      </>
    ),
  },
  {
    title: 'Broken or bent implant',
    body: (
      <>
        <p>
          Breakage or bending of the implant while it is in your arm may occur
          due to external forces (such as manipulation of the implant or contact
          sports). A broken implant may move from the insertion site.{' '}
          <span style={{ display: 'block' }}>
            If you feel that the implant may have broken or bent while in your
            arm, contact your healthcare professional.
          </span>
        </p>
      </>
    ),
  },
];

export const SE_TABLE_3 = [
  {
    title: 'Pain in your lower leg',
    body: 'That does not go away',
  },
  { title: 'Severe chest pain', body: 'Or heaviness in your chest' },
  {
    title: 'Sudden shortness of breath',
    body: 'Or sharp chest pain or coughing blood',
  },
  {
    title: 'Symptoms of severe allergic reaction',
    body: 'Such as swollen face, tongue, or throat, or have trouble breathing or swallowing',
  },
  { title: 'Sudden severe headache', body: 'Unlike your usual headaches' },
  {
    title: 'Weakness or numbness',
    body: 'In your arm or leg or trouble speaking',
  },
  { title: 'Sudden blindness', body: 'Either partial or complete' },
  {
    title: 'Yellowing of your skin or whites of your eyes',
    body: 'Especially with fever, tiredness, loss of appetite, dark-colored urine, or light-colored bowel movements',
  },
  {
    title: 'Severe abdominal pain or swelling',
    body: 'Severe pain, swelling, or tenderness in the lower stomach (abdomen)',
  },
  { title: 'Lump in your breast', body: '' },
  {
    title: 'Problems sleeping',
    body: 'Or lack of energy, tiredness, or you feel very sad',
  },
  {
    title: 'Heavy menstrual bleeding',
    body: 'Heavier than usual',
  },
  {
    title: 'Reason to believe the implant is broken or bent',
    body: 'For any reason',
  },
];
